module.exports = __webpack_public_path__ + "static/media/iphone_14_gold_pro_max.312f4790.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_gold_pro_max.jpg
// module id = 2134
// module chunks = 0